import React from 'react';
import { useTranslation } from 'react-i18next';
import { Container } from '@walmart-web/livingdesign-components';

import styles from './styles.module.css';
import { useAppSelector } from '../../../redux/hooks.ts';
import { ihutSelectors } from '../../../redux/slices/ihut.ts';
import TrackProductStep from '../TrackProductStep/index.tsx';
import TestStep from '../TestStep/index.tsx';
import ShareFeedbackStep from '../ShareFeedbackStep/index.tsx';
import Skeleton from '../../../components/Skeleton';
import ActivityNameHeader from '../ActivityNameHeader/index.tsx';
import Stepper from '../../../components/Stepper/index.tsx';
import ActivityInformation from '../ActivityInformation/index.tsx';

type Props = {
  activeStep: number;
};

const ActiveStepCardsContainer: React.FC<Props> = ({ activeStep }) => {
  if (activeStep === 0) return <TrackProductStep />;

  if (activeStep === 1) return <TestStep />;

  if (activeStep >= 2) return <ShareFeedbackStep />;

  return <></>;
};

const SelectedActivityContent = () => {
  const { t } = useTranslation('ihut');
  const activity = useAppSelector(ihutSelectors.selectSelectedActivity);
  const loading = useAppSelector(ihutSelectors.selectLoading);

  const STEPS = [
    { label: t('trackProductStep.title') },
    { label: t('testStep.title') },
    { label: t('shareFeedbackStep.title') }
  ];

  if (loading)
    return (
      <div className={styles.loadingContainer}>
        <Skeleton count={15} />
      </div>
    );
  if (!activity) return <></>;

  const currentStep = activity.stepStatus;
  const activityName = activity.surveyName || activity.name;

  return (
    <>
      <ActivityNameHeader activityName={activityName} />
      <Container className={styles.trackProductStepper}>
        <Stepper steps={STEPS} currentStep={currentStep} />
      </Container>
      <Container className={styles.infoContainer}>
        <ActivityInformation
          activeStep={currentStep}
          activityName={activityName}
          activityShortId={activity.shortId}
        />
      </Container>
      <Container className={styles.cardsContainer}>
        <ActiveStepCardsContainer activeStep={currentStep} />
      </Container>
    </>
  );
};

export default SelectedActivityContent;
